import { render } from "./TheSidebarResult.vue?vue&type=template&id=56db42f9&scoped=true"
import script from "./TheSidebarResult.vue?vue&type=script&lang=js"
export * from "./TheSidebarResult.vue?vue&type=script&lang=js"

import "./TheSidebarResult.vue?vue&type=style&index=0&id=56db42f9&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56db42f9"]])

export default __exports__